import { NhostClient } from '@nhost/nhost-js';
import {ENDPOINT_BASE} from 'constants/parameters';

export const server = new NhostClient({
  backendUrl: ENDPOINT_BASE
})